import styled from 'styled-components';

export const ControlledInputContainer = styled.div`
  & > div > span {
    margin: 0;
    height: 16px;
  }
`;
